export * from './equipments-new.component';
